import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const DescriptionBox = ({ content, onChange }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (content) {
      try {
        const rawContent = JSON.parse(content);
        setEditorState(EditorState.createWithContent(convertFromRaw(rawContent)));
      } catch (err) {
        setEditorState(EditorState.createEmpty());
      }
    }
  }, []);


  const handleEditorChange = (state) => {
    setEditorState(state);
    const raw = convertToRaw(state.getCurrentContent());

    // ✔ SEND OBJECT — NEVER STRING
    onChange(raw); // send pure object

  };

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleEditorChange}
      wrapperClassName="wrapper"
      editorClassName="editor"
      toolbarClassName="toolbar"

    />
  );
};

export default DescriptionBox;
